import AppPage from '../../mixins/app-page'
import Gateway from '../../utils/global/Gateway'


// URL list
import URL from '../../../config.url'


export default
{
    name: 'page-intra-video',

    mixins:
    [
        AppPage
    ],

    components: {},

    mounted()
    {
        this.eventHub.$emit('bg-change', '/static/bg/bg-empty.jpg')
        this._initJWPlayer()
    },
    
    destroyed()
    {
        if (this._playerInstance)
        {
            this._playerInstance.remove()
        }
    },

    methods:
    {
        _initJWPlayer()
        {
            const jwplayer = window.jwplayer
            if (jwplayer)
            {
                this._jwPlayerElmt = this.$el.querySelector('.js-jwplayer')

                const videoData = this.contentPage.video
                this._playerInstance = window.jwplayer(this._jwPlayerElmt)
                this._playerInstance = this._playerInstance.setup({
                    file: videoData.jwPlayerFile,
                    mediaid: videoData.jwPlayerID
                })
            }
            else
            {
                console.error('JWPLAYER not found')
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-intra-video/script.js